import { useMemo } from "react"
import { ImportCustomerTypeField, CsvContentSample } from "../../../../../features/importer"
import { Column, FieldType } from "../../../../../features/ui"
import { Data2 } from "../../../../../features/data-types"

interface Props {
    priceField: ImportCustomerTypeField
}

export const CustomerTypesCsvSample = (props: Props) => {
    const { priceField } = props

    const columnLabel = useMemo(() =>
        new Map([
            [ImportCustomerTypeField.PRICE, 'Precio'],
            [ImportCustomerTypeField.PRICE_VAT, 'PrecioIVA']
        ]).get(priceField)!
    , [priceField])

    const columns: Column[] = [
        {
            name: 'name',
            type: FieldType.TEXT,
            label: 'Nombre'
        },
        {
            name: 'yield',
            type: FieldType.PERCENTAGE,
            label: 'Ajuste'
        },
        {
            name: 'supplierCode',
            type: FieldType.TEXT,
            label: 'CodigoInterno'
        },
        {
            name: 'product',
            type: FieldType.TEXT,
            label: 'Producto'
        },
        {
            name: priceField,
            type: FieldType.PRICE,
            label: columnLabel
        }
    ]

    const rows: Data2[] = [
        {
            name: 'Nueva Lista',
            yield: -0.1
        },
        {
            supplierCode: 'A',
            product: 'Producto A',
            [priceField]: 1000
        },
        {
            supplierCode: 'B',
            product: 'Producto B',
            [priceField]: 2000
        },
        {
            supplierCode: 'C',
            product: 'Producto C',
            [priceField]: 3000
        }
    ]

    return <CsvContentSample columns={columns} rows={rows} />
}
